import Breadcrumb from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

interface PageLayoutProps {
  children: React.ReactNode;
  breadcrumb?: { label: string; path?: string }[];
}

export default function PageLayout({ children, breadcrumb }: PageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      {breadcrumb && <Breadcrumb items={breadcrumb} />}
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}